module.exports = __webpack_public_path__ + "static/media/icon-no-results.9af484e5.svg";